import React from "react";

const WebAppPreview = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1440"
      height="900"
      viewBox="0 0 1440 900"
    >
      <defs>
        <pattern
          id="pattern"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-1.webp"
          ></image>
        </pattern>
        <linearGradient
          id="linear-gradient"
          x2="1"
          y1="0.5"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#00afe4"></stop>
          <stop offset="1" stopColor="#5bc500"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          y1="0"
          y2="1"
          xlinkHref="#linear-gradient"
        ></linearGradient>
        <pattern
          id="pattern-3"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-2.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-4"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-3.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-5"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-4.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-6"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-5.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-7"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 512 512"
        >
          <image
            width="512"
            height="512"
            href="/img/preview-users/person-6.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-8"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-7.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-9"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-8.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-10"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-9.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-11"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-10.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-12"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-11.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-13"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-12.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-14"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 525 350"
        >
          <image
            width="525"
            height="350"
            href="/img/preview-users/person-13.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-15"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-14.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-16"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 200 200"
        >
          <image
            width="200"
            height="200"
            href="/img/preview-users/person-15.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-17"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 259 350"
        >
          <image
            width="259"
            height="350"
            href="/img/preview-users/person-16.webp"
          ></image>
        </pattern>
        <pattern
          id="pattern-18"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 525 350"
        >
          <image
            width="525"
            height="350"
            href="/img/preview-users/person-17.webp"
          ></image>
        </pattern>
        <linearGradient
          id="linear-gradient-4"
          x1="0.033"
          x2="0.961"
          y1="0.056"
          y2="0.936"
          xlinkHref="#linear-gradient"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1="0.019"
          x2="0.982"
          y1="0.075"
          y2="0.913"
          xlinkHref="#linear-gradient"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="0.719"
          x2="1.584"
          y1="0.036"
          y2="1.066"
          xlinkHref="#linear-gradient"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-9"
          x1="0.5"
          x2="0.5"
          y1="0"
          y2="1"
          xlinkHref="#linear-gradient"
        ></linearGradient>
        <clipPath id="clip-Dark_UI">
          <path d="M0 0H1440V900H0z"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-Dark_UI)" data-name="Dark UI">
        <path fill="var(--background-color)" d="M0 0H1440V900H0z"></path>
        <g data-name="Group 5569" transform="translate(0 -2003)">
          <path
            fill="var(--dark-grey)"
            d="M0 0H1440V72H0z"
            data-name="Rectangle 4348"
            transform="translate(0 2003)"
          ></path>
          <g transform="translate(-25 1999)">
            <rect
              width="326"
              height="42"
              fill="var(--white-05)"
              data-name="Rectangle 4011"
              rx="12"
              transform="translate(287 19)"
            ></rect>
            <text
              fill="var(--form-element-color)"
              data-name="Search"
              fontFamily="Inter"
              fontSize="14"
              opacity="0.5"
              transform="translate(331 45)"
            >
              <tspan x="0" y="0">
                Search
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/search-normal"
              opacity="0.7"
              transform="translate(-125 -156)"
            >
              <g
                fill="none"
                stroke="var(--form-element-color)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                transform="translate(428 188)"
              >
                <path d="M14 7.667a6.334 6.334 0 11-6.333-6.334A6.334 6.334 0 0114 7.667z"></path>
                <path d="M14.668 14.668l-2.265-2.183" data-name="Vector"></path>
              </g>
            </g>
          </g>
          <g data-name="Group 5568" transform="translate(0 1999)">
            <circle
              cx="20"
              cy="20"
              r="20"
              fill="url(#pattern)"
              data-name="Ellipse 735"
              transform="translate(1247 20)"
            ></circle>
            <text
              fill="var(--primary)"
              stroke="rgba(0,0,0,0)"
              strokeMiterlimit="10"
              strokeWidth="1"
              data-name="Frank Adams"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(1297 46)"
            >
              <tspan x="0" y="0">
                Frank Adams
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/arrow-square-down"
              transform="translate(1383.999 25)"
            >
              <g transform="translate(.001)">
                <path
                  fill="rgba(255,255,255,0)"
                  d="M9.333 26.667h8c6.667 0 9.333-2.667 9.333-9.333v-8C26.667 2.667 24 0 17.333 0h-8C2.667 0 0 2.667 0 9.333v8C0 24 2.667 26.667 9.333 26.667z"
                  data-name="Vector"
                  transform="translate(2.667 2.667)"
                ></path>
                <path
                  fill="none"
                  stroke="var(--primary)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M11.293 14.187L16 18.88l4.706-4.693"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g transform="translate(22 1999)">
            <circle
              cx="18"
              cy="18"
              r="18"
              fill="rgba(255,255,255,0)"
              data-name="Ellipse 736"
              transform="translate(1173 22)"
            ></circle>
            <g
              data-name="vuesax/linear/setting-2"
              transform="translate(881 -158)"
            >
              <g
                fill="none"
                stroke="var(--primary)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                transform="translate(300 188)"
              >
                <path
                  d="M12.5 10A2.5 2.5 0 1110 7.5a2.5 2.5 0 012.5 2.5z"
                  data-name="Vector"
                ></path>
                <path
                  d="M1.667 10.734V9.266A1.588 1.588 0 013.25 7.683c1.508 0 2.125-1.067 1.367-2.375A1.583 1.583 0 015.2 3.15l1.442-.825a1.391 1.391 0 011.9.5l.092.158c.75 1.308 1.983 1.308 2.742 0l.091-.158a1.391 1.391 0 011.9-.5l1.442.825a1.583 1.583 0 01.583 2.158c-.758 1.308-.142 2.375 1.367 2.375a1.588 1.588 0 011.583 1.583v1.468a1.588 1.588 0 01-1.583 1.583c-1.508 0-2.125 1.067-1.367 2.375a1.581 1.581 0 01-.583 2.158l-1.442.825a1.391 1.391 0 01-1.9-.5l-.092-.158c-.75-1.308-1.983-1.308-2.742 0l-.092.158a1.391 1.391 0 01-1.9.5l-1.442-.825a1.583 1.583 0 01-.583-2.158c.758-1.308.142-2.375-1.367-2.375a1.588 1.588 0 01-1.582-1.583z"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g transform="translate(32 1999)">
            <circle
              cx="18"
              cy="18"
              r="18"
              fill="rgba(255,255,255,0)"
              data-name="Ellipse 737"
              transform="translate(1119 22)"
            ></circle>
            <g
              data-name="vuesax/linear/notification-bing"
              transform="translate(1019 -158)"
            >
              <g
                fill="none"
                stroke="var(--primary)"
                strokeWidth="1.5"
                transform="translate(108 188)"
              >
                <path
                  strokeLinecap="round"
                  d="M9.998 5.365v2.774"
                  data-name="Vector"
                ></path>
                <path
                  strokeLinecap="round"
                  d="M10.014 1.666a5.547 5.547 0 00-5.548 5.549v1.751a4.326 4.326 0 01-.525 1.9L2.885 12.63a1.777 1.777 0 001 2.708 19.445 19.445 0 0012.272 0 1.849 1.849 0 001-2.708l-1.061-1.764a4.357 4.357 0 01-.525-1.9V7.215a5.581 5.581 0 00-5.557-5.549z"
                  data-name="Vector"
                ></path>
                <path
                  d="M12.772 15.68a2.784 2.784 0 01-2.775 2.774 2.779 2.779 0 01-1.958-.816 2.779 2.779 0 01-.816-1.958"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <g data-name="Group 5584">
          <g data-name="Group 5455" transform="translate(125 -90)">
            <text
              fill="var(--primary)"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(322 201)"
            >
              <tspan x="0" y="0">
                Inactive
              </tspan>
            </text>
            <circle
              cx="3"
              cy="3"
              r="3"
              fill="var(--danger)"
              data-name="Ellipse 21"
              transform="translate(308 193)"
            ></circle>
          </g>
          <g data-name="Group 5449" transform="translate(30 -90)">
            <text
              fill="var(--primary)"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(322 201)"
            >
              <tspan x="0" y="0">
                Active
              </tspan>
            </text>
            <circle
              cx="3"
              cy="3"
              r="3"
              fill="var(--success)"
              data-name="Ellipse 21"
              transform="translate(308 193)"
            ></circle>
          </g>
          <path
            fill="none"
            stroke="var(--white-10)"
            strokeWidth="1"
            d="M0 0L907 0"
            data-name="Line 155"
            transform="translate(264 130)"
          ></path>
          <path
            fill="url(#linear-gradient)"
            d="M0 0H50V2H0z"
            data-name="Rectangle 4246"
            transform="translate(264 128)"
          ></path>
          <path
            fill="url(#linear-gradient-2)"
            d="M-17544.877-3053v-10.18h2.121v10.18zm-3.807 0v-10.18h2.115v10.18zm-3.486 0l-.756-2.323h-3.68l-.756 2.323h-2.3l3.512-10.18h2.777l3.512 10.18zm-1.3-4l-1.254-3.852h-.078l-1.254 3.852z"
            data-name="Intersection 18"
            transform="translate(17840 3164.181)"
          ></path>
        </g>
        <g data-name="Group 5571" transform="translate(0 1)">
          <g
            fill="var(--primary)"
            data-name="Group 5474"
            transform="translate(384 -76)"
          >
            <rect
              width="136"
              height="36"
              data-name="Rectangle 2"
              opacity="0.05"
              rx="12"
              transform="translate(146 225)"
            ></rect>
            <text
              data-name="Laura’s Client"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(170 248)"
            >
              <tspan x="0" y="0">
                Laura’s Client
              </tspan>
            </text>
          </g>
          <g
            fill="var(--primary)"
            data-name="Group 5592"
            transform="translate(246 -76)"
          >
            <rect
              width="130"
              height="36"
              data-name="Rectangle 2"
              opacity="0.05"
              rx="12"
              transform="translate(146 225)"
            ></rect>
            <text
              data-name="Mike’s Client"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(170 248)"
            >
              <tspan x="0" y="0">
                Mike’s Client
              </tspan>
            </text>
          </g>
          <rect
            width="120"
            height="36"
            fill="var(--primary)"
            data-name="Rectangle 2"
            opacity="0.05"
            rx="12"
            transform="translate(264 149)"
          ></rect>
          <g
            fill="var(--primary)"
            data-name="Group 5475"
            transform="translate(528 -76)"
          >
            <rect
              width="167"
              height="36"
              data-name="Rectangle 2"
              opacity="0.05"
              rx="12"
              transform="translate(146 225)"
            ></rect>
            <text
              data-name="Weekend Workers"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(170 248)"
            >
              <tspan x="0" y="0">
                Weekend Workers
              </tspan>
            </text>
          </g>
          <g
            fill="var(--primary)"
            data-name="Group 5476"
            transform="translate(703 -76)"
          >
            <rect
              width="127"
              height="36"
              data-name="Rectangle 2"
              opacity="0.05"
              rx="12"
              transform="translate(146 225)"
            ></rect>
            <text
              fontFamily="Inter"
              fontSize="14"
              transform="translate(170 248)"
            >
              <tspan x="0" y="0">
                Participants
              </tspan>
            </text>
          </g>
          <path
            fill="url(#linear-gradient-2)"
            d="M-17494.5-3053.332a3.165 3.165 0 01-1.3-1.357 4.505 4.505 0 01-.459-2.093 4.489 4.489 0 01.459-2.071 3.357 3.357 0 011.291-1.384 3.685 3.685 0 011.951-.5 4.075 4.075 0 011.41.238 3.212 3.212 0 011.146.727 3.329 3.329 0 01.762 1.212 4.846 4.846 0 01.273 1.7v.582h-5.2a2.145 2.145 0 00.211.983 1.54 1.54 0 00.6.635 1.846 1.846 0 00.916.22 2 2 0 00.648-.1 1.441 1.441 0 00.5-.3 1.261 1.261 0 00.318-.485l1.955.128a2.634 2.634 0 01-.607 1.234 3.06 3.06 0 01-1.182.811 4.462 4.462 0 01-1.67.291 4.057 4.057 0 01-2.022-.471zm3.537-4.257a1.7 1.7 0 00-.2-.811 1.493 1.493 0 00-.551-.555 1.578 1.578 0 00-.812-.2 1.61 1.61 0 00-.85.225 1.628 1.628 0 00-.582.591 1.73 1.73 0 00-.209.754zm-17.266 4.257a3.233 3.233 0 01-1.3-1.357 4.505 4.505 0 01-.459-2.093 4.489 4.489 0 01.459-2.071 3.408 3.408 0 011.291-1.384 3.7 3.7 0 011.957-.5 4.1 4.1 0 011.41.238 3.24 3.24 0 011.141.727 3.307 3.307 0 01.764 1.212 4.755 4.755 0 01.277 1.7v.582h-5.205a2.145 2.145 0 00.211.983 1.554 1.554 0 00.605.635 1.815 1.815 0 00.916.22 1.979 1.979 0 00.643-.1 1.415 1.415 0 00.508-.3 1.248 1.248 0 00.313-.485l1.961.128a2.749 2.749 0 01-.607 1.234 3.06 3.06 0 01-1.182.811 4.483 4.483 0 01-1.67.291 4.09 4.09 0 01-2.036-.471zm3.543-4.257a1.636 1.636 0 00-.207-.811 1.451 1.451 0 00-.551-.555 1.552 1.552 0 00-.807-.2 1.631 1.631 0 00-.855.225 1.612 1.612 0 00-.576.591 1.659 1.659 0 00-.215.754zm5.086 4.491a1.853 1.853 0 01-.895-.727 2.218 2.218 0 01-.312-1.243v-3.979h-1.045v-1.591h1.045v-1.829h2.115v1.829h1.441v1.591h-1.441v3.7a.951.951 0 00.092.458.477.477 0 00.256.225.958.958 0 00.371.066 1.733 1.733 0 00.3-.026c.1-.018.176-.035.229-.044l.336 1.578a5.094 5.094 0 01-.449.119 3.761 3.761 0 01-.7.079h-.182a3.067 3.067 0 01-1.161-.208zm-26.512 0a1.844 1.844 0 01-.895-.727 2.218 2.218 0 01-.314-1.243v-3.979h-1.043v-1.591h1.043v-1.829h2.115v1.829h1.441v1.591h-1.441v3.7a.927.927 0 00.094.458.473.473 0 00.25.225 1.007 1.007 0 00.375.066 1.706 1.706 0 00.3-.026c.1-.018.176-.035.229-.044l.334 1.578a4.908 4.908 0 01-.449.119 3.738 3.738 0 01-.7.079h-.182a3.075 3.075 0 01-1.16-.208zm12.621.1v-10.18h2.115V-3053zm-3.785 0v-4.486a1.544 1.544 0 00-.357-1.1 1.307 1.307 0 00-1.01-.392 1.543 1.543 0 00-.762.185 1.276 1.276 0 00-.516.533 1.722 1.722 0 00-.189.842v4.416h-2.121v-10.18h2.059v3.891h.088a2.177 2.177 0 01.838-1.058 2.526 2.526 0 011.445-.388 2.732 2.732 0 011.393.344 2.355 2.355 0 01.922.987 3.288 3.288 0 01.326 1.538v4.866zm-13.557 0l-.756-2.323h-3.68l-.756 2.323h-2.3l3.512-10.18h2.777l3.512 10.18zm-1.3-4l-1.254-3.852h-.078l-1.254 3.852zm-12.738 4v-10.18h2.121V-3053zm-3.807 0v-10.18h2.115V-3053zm-3.486 0l-.756-2.323h-3.68l-.756 2.323h-2.3l3.512-10.18h2.777l3.512 10.18zm-1.3-4l-1.254-3.852h-.078l-1.254 3.852z"
            data-name="Intersection 20"
            transform="translate(17848 3225)"
          ></path>
        </g>
        <g data-name="Group 4880" transform="translate(599 -1000)">
          <rect
            width="36"
            height="36"
            fill="var(--primary)"
            data-name="Rectangle 2"
            opacity="0.1"
            rx="12"
            transform="translate(385 1150)"
          ></rect>
          <g data-name="vuesax/linear/add" transform="translate(389 1154)">
            <g
              fill="none"
              stroke="var(--primary)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M6.751 14h14.5" data-name="Vector"></path>
              <path d="M14 21.251v-14.5" data-name="Vector"></path>
            </g>
          </g>
        </g>
        <g data-name="Group 4440" transform="translate(-4 49)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2205"
            rx="12"
            transform="translate(482 169)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern)"
            data-name="Ellipse 227"
            transform="translate(538 201)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Tom Ellis"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(585 326)"
          >
            <tspan x="-29.905" y="0">
              Tom Ellis
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="John’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(585 343)"
          >
            <tspan x="-30.347" y="0">
              John’s Client
            </tspan>
          </text>
        </g>
        <g data-name="Group 4439" transform="translate(-8 49)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2206"
            rx="12"
            transform="translate(700 169)"
          ></rect>
          <text
            fill="var(--primary)"
            data-name="Roy Barrett"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(803 326)"
          >
            <tspan x="-37.882" y="0">
              Roy Barrett
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="John’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(803 343)"
          >
            <tspan x="-30.347" y="0">
              John’s Client
            </tspan>
          </text>
          <g data-name="Group 5701">
            <circle
              cx="47.5"
              cy="47.5"
              r="47.5"
              fill="var(--primary)"
              data-name="Ellipse 819"
              opacity="0.05"
              transform="translate(756 201)"
            ></circle>
            <g data-name="vuesax/linear/user" transform="translate(676 41)">
              <g
                fill="none"
                stroke="var(--primary)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                transform="translate(108 188)"
              >
                <path
                  d="M27.626 11.378A8.127 8.127 0 1119.5 3.251a8.127 8.127 0 018.126 8.127z"
                  data-name="Vector"
                ></path>
                <path
                  d="M33.457 35.749c0-6.29-6.256-11.377-13.957-11.377S5.542 29.459 5.542 35.749"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <g data-name="Group 4438" transform="translate(-12 49)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2207"
            rx="12"
            transform="translate(918 169)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-3)"
            data-name="Ellipse 229"
            transform="translate(974 201)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Laura’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(1021 343)"
          >
            <tspan x="-31.963" y="0">
              Laura’s Client
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="Michelle Stanley"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(1021 326)"
          >
            <tspan x="-55.573" y="0">
              Michelle Stanley
            </tspan>
          </text>
        </g>
        <g data-name="Group 4433" transform="translate(-16 49)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 4065"
            rx="12"
            transform="translate(1136 169)"
          ></rect>
          <text
            fill="var(--primary)"
            data-name="John’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(1239 343)"
          >
            <tspan x="-30.347" y="0">
              John’s Client
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="Jeremy Reid"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(1239 326)"
          >
            <tspan x="-41.638" y="0">
              Jeremy Reid
            </tspan>
          </text>
          <g data-name="Group 5702" transform="translate(436)">
            <circle
              cx="47.5"
              cy="47.5"
              r="47.5"
              fill="var(--primary)"
              data-name="Ellipse 819"
              opacity="0.05"
              transform="translate(756 201)"
            ></circle>
            <g data-name="vuesax/linear/user" transform="translate(676 41)">
              <g
                fill="none"
                stroke="var(--primary)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                data-name="user"
                transform="translate(108 188)"
              >
                <path
                  d="M27.626 11.378A8.127 8.127 0 1119.5 3.251a8.127 8.127 0 018.126 8.127z"
                  data-name="Vector"
                ></path>
                <path
                  d="M33.457 35.749c0-6.29-6.256-11.377-13.957-11.377S5.542 29.459 5.542 35.749"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <g data-name="Group 4436" transform="translate(-11 35)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2210"
            rx="12"
            transform="translate(703 383)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-4)"
            data-name="Ellipse 231"
            transform="translate(759 415)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Carol Cooper"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(806 540)"
          >
            <tspan x="-44.679" y="0">
              Carol Cooper
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="John’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(806 557)"
          >
            <tspan x="-30.347" y="0">
              John’s Client
            </tspan>
          </text>
        </g>
        <g data-name="Group 4437" transform="translate(-17 35)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 4060"
            rx="12"
            transform="translate(923 383)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-5)"
            data-name="Ellipse 758"
            transform="translate(979 415)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Kathryn Reynolds"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(1026 540)"
          >
            <tspan x="-59.898" y="0">
              Kathryn Reynolds
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="Laura’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(1026 557)"
          >
            <tspan x="-31.963" y="0">
              Laura’s Client
            </tspan>
          </text>
        </g>
        <g data-name="Group 4432" transform="translate(-24 35)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 4066"
            rx="12"
            transform="translate(1144 383)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-6)"
            data-name="Ellipse 763"
            transform="translate(1200 415)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Denise Garrett"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(1247 540)"
          >
            <tspan x="-49.209" y="0">
              Denise Garrett
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="Laura’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(1247 557)"
          >
            <tspan x="-31.963" y="0">
              Laura’s Client
            </tspan>
          </text>
        </g>
        <g data-name="Group 4434" transform="translate(1 35)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2208"
            rx="12"
            transform="translate(263 383)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-7)"
            data-name="Ellipse 230"
            transform="translate(319 415)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Pamela Ross"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(366 540)"
          >
            <tspan x="-42.915" y="0">
              Pamela Ross
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="John’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(366 557)"
          >
            <tspan x="-30.347" y="0">
              John’s Client
            </tspan>
          </text>
        </g>
        <g data-name="Group 4435" transform="translate(-5 35)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2209"
            rx="12"
            transform="translate(483 383)"
          ></rect>
          <text
            fill="var(--primary)"
            data-name="Laura’s Client"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(586 557)"
          >
            <tspan x="-31.963" y="0">
              Laura’s Client
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="Rachel Gray"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(586 540)"
          >
            <tspan x="-40.526" y="0">
              Rachel Gray
            </tspan>
          </text>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-8)"
            data-name="Ellipse 242"
            transform="translate(539 415)"
          ></circle>
        </g>
        <g data-name="Group 4442" transform="translate(0 49)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 2195"
            rx="12"
            transform="translate(264 169)"
          ></rect>
          <circle
            cx="47.5"
            cy="47.5"
            r="47.5"
            fill="url(#pattern-9)"
            data-name="Ellipse 209"
            transform="translate(320 201)"
          ></circle>
          <text
            fill="var(--primary)"
            data-name="Benjamin Chavez"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="700"
            transform="translate(310 326)"
          >
            <tspan x="0" y="0">
              Benjamin Chavez
            </tspan>
          </text>
          <text
            fill="var(--primary)"
            data-name="Checkemail123@gmail.com"
            fontFamily="Inter"
            fontSize="10"
            fontWeight="500"
            opacity="0.5"
            transform="translate(369 343)"
          >
            <tspan x="-65.835" y="0">
              Checkemail123@gmail.com
            </tspan>
          </text>
          <g data-name="Group 4441">
            <rect
              width="80"
              height="20"
              fill="var(--white-05)"
              data-name="Rectangle 4090"
              rx="10"
              transform="translate(382 177)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Test Account"
              fontFamily="Inter"
              fontSize="10"
              fontWeight="500"
              transform="translate(422 191)"
            >
              <tspan x="-31.624" y="0">
                Test Account
              </tspan>
            </text>
          </g>
        </g>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 2206"
          rx="12"
          transform="translate(692 618)"
        ></rect>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 4093"
          rx="12"
          transform="translate(692 818)"
        ></rect>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 4095"
          rx="12"
          transform="translate(478 818)"
        ></rect>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-10)"
          data-name="Ellipse 228"
          transform="translate(748 650)"
        ></circle>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-11)"
          data-name="Ellipse 783"
          transform="translate(748 850)"
        ></circle>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-12)"
          data-name="Ellipse 785"
          transform="translate(534 850)"
        ></circle>
        <text
          fill="var(--primary)"
          data-name="Craig Coleman"
          fontFamily="Inter"
          fontSize="14"
          fontWeight="600"
          transform="translate(795 775)"
        >
          <tspan x="-49.881" y="0">
            Craig Coleman
          </tspan>
        </text>
        <text
          fill="var(--primary)"
          data-name="John’s Client"
          fontFamily="Inter"
          fontSize="10"
          fontWeight="500"
          opacity="0.5"
          transform="translate(795 792)"
        >
          <tspan x="-30.347" y="0">
            John’s Client
          </tspan>
        </text>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 2206"
          rx="12"
          transform="translate(264 618)"
        ></rect>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 4094"
          rx="12"
          transform="translate(264 818)"
        ></rect>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-13)"
          data-name="Ellipse 228"
          transform="translate(320 650)"
        ></circle>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-14)"
          data-name="Ellipse 784"
          transform="translate(320 850)"
        ></circle>
        <text
          fill="var(--primary)"
          data-name="Tom Gilbert"
          fontFamily="Inter"
          fontSize="14"
          fontWeight="600"
          transform="translate(367 775)"
        >
          <tspan x="-39.713" y="0">
            Tom Gilbert
          </tspan>
        </text>
        <text
          fill="var(--primary)"
          data-name="John’s Client"
          fontFamily="Inter"
          fontSize="10"
          fontWeight="500"
          opacity="0.5"
          transform="translate(367 792)"
        >
          <tspan x="-30.347" y="0">
            John’s Client
          </tspan>
        </text>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 2207"
          rx="12"
          transform="translate(906 618)"
        ></rect>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 4092"
          rx="12"
          transform="translate(906 818)"
        ></rect>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-15)"
          data-name="Ellipse 229"
          transform="translate(962 650)"
        ></circle>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-16)"
          data-name="Ellipse 782"
          transform="translate(962 850)"
        ></circle>
        <text
          fill="var(--primary)"
          data-name="Laura’s Client"
          fontFamily="Inter"
          fontSize="10"
          fontWeight="500"
          opacity="0.5"
          transform="translate(1009 792)"
        >
          <tspan x="-31.963" y="0">
            Laura’s Client
          </tspan>
        </text>
        <text
          fill="var(--primary)"
          data-name="Doris Lawson"
          fontFamily="Inter"
          fontSize="14"
          fontWeight="600"
          transform="translate(1009 775)"
        >
          <tspan x="-45.719" y="0">
            Doris Lawson
          </tspan>
        </text>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 4065"
          rx="12"
          transform="translate(1120 618)"
        ></rect>
        <rect
          width="206"
          height="192"
          fill="var(--dark-grey)"
          data-name="Rectangle 4091"
          rx="12"
          transform="translate(1120 818)"
        ></rect>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-17)"
          data-name="Ellipse 764"
          transform="translate(1176 650)"
        ></circle>
        <circle
          cx="47.5"
          cy="47.5"
          r="47.5"
          fill="url(#pattern-18)"
          data-name="Ellipse 781"
          transform="translate(1176 850)"
        ></circle>
        <text
          fill="var(--primary)"
          data-name="John’s Client"
          fontFamily="Inter"
          fontSize="10"
          fontWeight="500"
          opacity="0.5"
          transform="translate(1223 792)"
        >
          <tspan x="-30.347" y="0">
            John’s Client
          </tspan>
        </text>
        <text
          fill="var(--primary)"
          data-name="Debra Green"
          fontFamily="Inter"
          fontSize="14"
          fontWeight="600"
          transform="translate(1223 775)"
        >
          <tspan x="-42.563" y="0">
            Debra Green
          </tspan>
        </text>
        <g data-name="Group 4431" transform="translate(-240 21)">
          <rect
            width="206"
            height="192"
            fill="var(--dark-grey)"
            data-name="Rectangle 4089"
            rx="12"
            transform="translate(718 597)"
          ></rect>
          <g data-name="Group 4430" transform="translate(-2 -3)">
            <g data-name="Group 4425" transform="translate(0 -16)">
              <rect
                width="190"
                height="32"
                fill="rgba(255,255,255,0)"
                data-name="Rectangle 4088"
                rx="8"
                transform="translate(728 768)"
              ></rect>
              <text
                fill="var(--primary)"
                fontFamily="Inter"
                fontSize="12"
                transform="translate(776 789)"
              >
                <tspan x="0" y="0">
                  Nutrition
                </tspan>
              </text>
              <path
                fill="var(--primary)"
                d="M10.987 20a4.144 4.144 0 01-2.32-.64 1.057 1.057 0 00-1.373 0 4.144 4.144 0 01-2.319.64 2.934 2.934 0 01-1.957-.922 8.468 8.468 0 01-1.5-1.953A10.865 10.865 0 010 12.018c0-5.551 2.713-6.634 4.332-6.786a6.176 6.176 0 012.223.319 5.663 5.663 0 001.425.273 5.7 5.7 0 001.431-.272 6.233 6.233 0 012.215-.319A4.161 4.161 0 0115 7.37a9.3 9.3 0 01.962 4.649 10.866 10.866 0 01-1.522 5.106 8.469 8.469 0 01-1.5 1.953 2.935 2.935 0 01-1.953.922zM7.98 17.433a2.844 2.844 0 011.52.477 2.513 2.513 0 001.482.416c.333 0 1.14-.542 2-2.036a9.273 9.273 0 001.3-4.27 7.866 7.866 0 00-.738-3.82 2.456 2.456 0 00-2.069-1.3 4.84 4.84 0 00-1.622.266 7.008 7.008 0 01-1.875.334 6.974 6.974 0 01-1.872-.333A4.788 4.788 0 004.484 6.9 2.5 2.5 0 002.45 8.212a7.643 7.643 0 00-.778 3.808 9.271 9.271 0 001.3 4.269c.861 1.494 1.669 2.036 2 2.036a2.513 2.513 0 001.482-.416 2.844 2.844 0 011.525-.479zM11.209 3.52a5.4 5.4 0 01-3.084 1.51.412.412 0 01-.475-.458 5.117 5.117 0 011.5-3.111A4.869 4.869 0 0112.228 0a.42.42 0 01.456.38.415.415 0 010 .088 5.138 5.138 0 01-1.475 3.052z"
                opacity="0.5"
                transform="translate(744 774)"
              ></path>
            </g>
            <g data-name="Group 4426" transform="translate(0 -12)">
              <rect
                width="190"
                height="32"
                fill="rgba(255,255,255,0)"
                data-name="Rectangle 4087"
                rx="8"
                transform="translate(728 728)"
              ></rect>
              <text
                fill="var(--primary)"
                fontFamily="Inter"
                fontSize="12"
                transform="translate(776 749)"
              >
                <tspan x="0" y="0">
                  Reports
                </tspan>
              </text>
              <g
                data-name="vuesax/linear/chart"
                opacity="0.5"
                transform="translate(316 482)"
              >
                <g transform="translate(428 252)">
                  <path
                    fill="none"
                    stroke="var(--primary)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M2.5 18.333h15"
                    data-name="Vector"
                  ></path>
                  <g fill="var(--primary)" transform="translate(2.5 1.667)">
                    <path
                      d="M2.167 0H.833A.836.836 0 000 .833v7.184a.836.836 0 00.833.833h1.334A.836.836 0 003 8.017V.833A.836.836 0 002.167 0z"
                      data-name="Vector"
                      transform="translate(0 5.317)"
                    ></path>
                    <path
                      d="M2.167 0H.833A.836.836 0 000 .833v9.842a.836.836 0 00.833.833h1.334A.836.836 0 003 10.675V.833A.836.836 0 002.167 0z"
                      data-name="Vector"
                      transform="translate(12 2.658)"
                    ></path>
                    <path
                      d="M2.167 0H.833A.836.836 0 000 .833v12.5a.836.836 0 00.833.833h1.334A.836.836 0 003 13.333V.833A.836.836 0 002.167 0z"
                      data-name="Vector"
                      transform="translate(6)"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
            <g data-name="Group 4427" transform="translate(0 -8)">
              <rect
                width="190"
                height="32"
                fill="rgba(255,255,255,0)"
                data-name="Rectangle 4086"
                rx="8"
                transform="translate(728 688)"
              ></rect>
              <text
                fill="var(--primary)"
                fontFamily="Inter"
                fontSize="12"
                transform="translate(776 709)"
              >
                <tspan x="0" y="0">
                  Calendar
                </tspan>
              </text>
              <g
                data-name="vuesax/linear/calendar"
                opacity="0.5"
                transform="translate(252 506)"
              >
                <g
                  fill="none"
                  stroke="var(--primary)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  data-name="calendar"
                  transform="translate(492 188)"
                >
                  <path
                    strokeWidth="1.5"
                    d="M6.667 1.667v2.5"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="1.5"
                    d="M13.333 1.667v2.5"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="1.5"
                    d="M2.917 7.575h14.167"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="1.5"
                    d="M17.5 7.084v7.083c0 2.5-1.25 4.167-4.167 4.167H6.667c-2.917 0-4.167-1.667-4.167-4.167V7.084c0-2.5 1.25-4.167 4.167-4.167h6.667c2.916 0 4.166 1.667 4.166 4.167z"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="2"
                    d="M13.079 11.417h.005"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="2"
                    d="M13.079 13.917h.005"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="2"
                    d="M9.997 11.417h.005"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="2"
                    d="M9.997 13.917h.005"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="2"
                    d="M6.912 11.417h.005"
                    data-name="Vector"
                  ></path>
                  <path
                    strokeWidth="2"
                    d="M6.912 13.917h.005"
                    data-name="Vector"
                  ></path>
                </g>
              </g>
            </g>
            <g data-name="Group 4428" transform="translate(0 -4)">
              <rect
                width="190"
                height="32"
                fill="rgba(255,255,255,0)"
                data-name="Rectangle 4085"
                rx="8"
                transform="translate(728 648)"
              ></rect>
              <text
                fill="var(--primary)"
                fontFamily="Inter"
                fontSize="12"
                transform="translate(776 669)"
              >
                <tspan x="0" y="0">
                  Programs
                </tspan>
              </text>
              <g opacity="0.5" transform="translate(744 653.584)">
                <path
                  fill="none"
                  d="M0 0h19.983v19.519H0z"
                  data-name="Path 1408"
                ></path>
                <path
                  fill="var(--primary)"
                  d="M15.459 5.184l-2.842-2.837A1 1 0 1011.2 3.756l2.117 2.117-8.085 8.089-2.116-2.117a1 1 0 10-1.409 1.412l2.807 2.812 2.806 2.807a1 1 0 001.418-1.409l-2.082-2.081L14.745 7.3l2.112 2.111a1 1 0 001.409-1.418zM1.707 16.08A1 1 0 00.29 17.5l2.826 2.826a1 1 0 101.418-1.418zM19.684 3.756L16.857.93a1 1 0 00-1.417 1.417l2.826 2.826a1 1 0 101.418-1.418z"
                  data-name="Path 1409"
                  transform="translate(.004 .197)"
                ></path>
              </g>
            </g>
            <g data-name="Group 4429">
              <rect
                width="190"
                height="32"
                fill="var(--white-05)"
                data-name="Rectangle 4084"
                rx="8"
                transform="translate(728 608)"
              ></rect>
              <text
                fill="var(--primary)"
                fontFamily="Inter"
                fontSize="12"
                transform="translate(776 629)"
              >
                <tspan x="0" y="0">
                  Profile
                </tspan>
              </text>
              <g data-name="vuesax/linear/user" transform="translate(636 426)">
                <g
                  fill="none"
                  stroke="var(--primary)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  data-name="user"
                  transform="translate(108 188)"
                >
                  <path
                    d="M14.166 5.834A4.167 4.167 0 1110 1.667a4.167 4.167 0 014.166 4.167z"
                    data-name="Vector"
                  ></path>
                  <path
                    d="M17.159 18.333c0-3.225-3.209-5.833-7.159-5.833s-7.158 2.608-7.158 5.833"
                    data-name="Vector"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g data-name="Component 1 – 26" transform="translate(1187.003 91.001)">
          <g
            data-name="vuesax/linear/arrow-square-down"
            transform="translate(44.999 8)"
          >
            <g data-name="arrow-square-down" transform="translate(.001)">
              <path
                fill="rgba(255,255,255,0)"
                d="M5.833 16.664h5c4.166 0 5.833-1.666 5.833-5.833v-5C16.664 1.666 15 0 10.832 0h-5C1.666 0 0 1.666 0 5.833v5C0 15 1.666 16.664 5.833 16.664z"
                data-name="Vector"
                transform="translate(1.666 1.666)"
              ></path>
              <path
                fill="none"
                stroke="var(--primary)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M5.998 8.004l4 3.989 4-3.989"
                data-name="Vector"
              ></path>
            </g>
          </g>
          <text
            fill="var(--primary)"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(12 23)"
          >
            <tspan x="0" y="0">
              Sort
            </tspan>
          </text>
        </g>
        <g data-name="Group 5579" transform="translate(962 -771)">
          <rect
            width="144"
            height="42"
            fill="url(#linear-gradient-4)"
            data-name="Rectangle 2"
            rx="12"
            transform="translate(310 859)"
          ></rect>
          <text
            fill="var(--primary)"
            data-name="Add Athlete"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(356 884)"
          >
            <tspan x="0" y="0">
              Add Athlete
            </tspan>
          </text>
          <g data-name="vuesax/linear/add" transform="translate(-164 618)">
            <g
              fill="none"
              stroke="var(--primary)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              data-name="add"
              transform="translate(492 252)"
            >
              <path d="M5 10h10" data-name="Vector"></path>
              <path d="M10 15V5" data-name="Vector"></path>
            </g>
          </g>
        </g>
        <g data-name="Dark Menu">
          <path
            fill="var(--dark-grey)"
            d="M0 0H240V900H0z"
            data-name="Rectangle 4016"
          ></path>
          <g
            data-name="MSB University"
            opacity="0.7"
            transform="translate(0 -1504)"
          >
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 2142)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="MSB University"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 2168)"
            >
              <tspan x="0" y="0">
                Msb University
              </tspan>
            </text>
            <g data-name="vuesax/linear/bank" transform="translate(-404 1962)">
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path
                  d="M440.37 190.15l9 3.6a1.083 1.083 0 01.63.93V198a1 1 0 01-1 1h-18a1 1 0 01-1-1v-3.32a1.083 1.083 0 01.63-.93l9-3.6a1.171 1.171 0 01.74 0z"
                  data-name="Vector"
                ></path>
                <path
                  d="M450 210h-20v-3a1 1 0 011-1h18a1 1 0 011 1z"
                  data-name="Vector"
                ></path>
                <path d="M432 206v-7" data-name="Vector"></path>
                <path d="M436 206v-7" data-name="Vector"></path>
                <path d="M440 206v-7" data-name="Vector"></path>
                <path d="M444 206v-7" data-name="Vector"></path>
                <path d="M448 206v-7" data-name="Vector"></path>
                <path d="M429 210h22" data-name="Vector"></path>
                <path
                  d="M441.5 195a1.5 1.5 0 11-1.5-1.5 1.5 1.5 0 011.5 1.5z"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g data-name="Simple Line (menu)" transform="translate(16 622)">
            <path
              fill="none"
              stroke="var(--white-10)"
              strokeWidth="1"
              d="M-.001 0h224"
              data-name="Path 1568"
            ></path>
          </g>
          <g opacity="0.7" transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 2062)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Chat"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 2088)"
            >
              <tspan x="0" y="0">
                Chat
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/messages-2"
              transform="translate(-404 1820)"
            >
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path
                  d="M446.47 266.83l.39 3.16a1 1 0 01-1.5.98l-4.19-2.49a9.982 9.982 0 01-1.35-.09 4.861 4.861 0 001.18-3.16 5.327 5.327 0 00-5.5-5.14 5.683 5.683 0 00-3.12.91 6.339 6.339 0 01-.04-.76c0-4.55 3.95-8.24 8.83-8.24s8.83 3.69 8.83 8.24a8.054 8.054 0 01-3.53 6.59z"
                  data-name="Vector"
                ></path>
                <path
                  d="M441 265.23a4.861 4.861 0 01-1.18 3.16 5.584 5.584 0 01-4.32 1.97l-2.61 1.55a.625.625 0 01-.94-.61l.25-1.97a4.988 4.988 0 01-2.2-4.1 5.023 5.023 0 012.38-4.23 5.683 5.683 0 013.12-.91 5.327 5.327 0 015.5 5.14z"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g data-name="Task List" opacity="0.7" transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 2022)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Task List"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 2048)"
            >
              <tspan x="0" y="0">
                Task List
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/tick-circle"
              transform="translate(-724 1842)"
            >
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path
                  d="M760 210a10 10 0 10-10-10 10.029 10.029 0 0010 10z"
                  data-name="Vector"
                ></path>
                <path
                  d="M755.75 200l2.83 2.83 5.67-5.66"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <rect
            width="216"
            height="40"
            fill="url(#linear-gradient-5)"
            data-name="Rectangle 4010"
            rx="8"
            transform="translate(12 478)"
          ></rect>
          <text
            fill="var(--primary)"
            data-name="Athlete List"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="700"
            transform="translate(60 504)"
          >
            <tspan x="0" y="0">
              Athlete List
            </tspan>
          </text>
          <g data-name="vuesax/linear/user" transform="translate(-84 298)">
            <g
              fill="none"
              stroke="var(--primary)"
              strokeWidth="1"
              data-name="user"
            >
              <path
                d="M125 195a5 5 0 11-5-5 5 5 0 015 5z"
                data-name="Vector"
              ></path>
              <path
                d="M128.59 210c0-3.87-3.85-7-8.59-7s-8.59 3.13-8.59 7"
                data-name="Vector"
              ></path>
            </g>
          </g>
          <g
            data-name="Athlete Overview"
            opacity="0.7"
            transform="translate(0 -1504)"
          >
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1942)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Athlete Overview"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 1968)"
            >
              <tspan x="0" y="0">
                Athlete Overview
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/clipboard-text"
              transform="translate(-84 1698)"
            >
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path d="M116 264.2h7" data-name="Vector"></path>
                <path d="M116 268.2h4.38" data-name="Vector"></path>
                <path
                  d="M118 258h4c2 0 2-1 2-2 0-2-1-2-2-2h-4c-1 0-2 0-2 2s1 2 2 2z"
                  data-name="Vector"
                ></path>
                <path
                  d="M124 256.02c3.33.18 5 1.41 5 5.98v6c0 4-1 6-6 6h-6c-5 0-6-2-6-6v-6c0-4.56 1.67-5.8 5-5.98"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <path
              fill="none"
              stroke="var(--white-10)"
              strokeWidth="1"
              d="M77.999 414.5h162"
              data-name="Path 1567"
            ></path>
            <text
              fill="var(--primary)"
              data-name="Coaching"
              fontFamily="Inter"
              fontSize="12"
              opacity="0.5"
              transform="translate(16 419)"
            >
              <tspan x="0" y="0">
                Coaching
              </tspan>
            </text>
          </g>
          <g opacity="0.7" transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1847)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Income"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 1873)"
            >
              <tspan x="0" y="0">
                Income
              </tspan>
            </text>
            <g
              fill="none"
              stroke="var(--primary)"
              strokeWidth="1"
              transform="translate(-340 1411)"
            >
              <g data-name="Group">
                <path
                  d="M373.5 457.75a1.711 1.711 0 001.67 1.75h1.88a1.489 1.489 0 001.45-1.53 1.321 1.321 0 00-.99-1.45l-3.01-1.05a1.314 1.314 0 01-.99-1.45 1.5 1.5 0 011.45-1.53h1.88a1.711 1.711 0 011.67 1.75"
                  data-name="Vector"
                ></path>
                <path d="M376 451.5v9" data-name="Vector"></path>
              </g>
              <path d="M386 456a10 10 0 11-10-10" data-name="Vector"></path>
              <path d="M381 447v4h4" data-name="Vector"></path>
              <path d="M386 446l-5 5" data-name="Vector"></path>
            </g>
          </g>
          <g
            data-name="Subscriber List"
            opacity="0.7"
            transform="translate(0 -1504)"
          >
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1807)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Subscriber List"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 1833)"
            >
              <tspan x="0" y="0">
                Subscriber List
              </tspan>
            </text>
            <g data-name="vuesax/linear/task" transform="translate(-404 1499)">
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path d="M439 335.5h10" data-name="Vector"></path>
                <path d="M439 328.5h10" data-name="Vector"></path>
                <path d="M439 321.5h10" data-name="Vector"></path>
                <path
                  d="M433.07 337.5a.469.469 0 00-.147 0 2 2 0 11.147 0z"
                  data-name="Vector"
                ></path>
                <path
                  d="M433.07 330.5a.469.469 0 00-.147 0 2 2 0 11.147 0z"
                  data-name="Vector"
                ></path>
                <path
                  d="M433.07 323.5a.469.469 0 00-.147 0 2 2 0 11.147 0z"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g opacity="0.7" transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1767)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Store"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 1793)"
            >
              <tspan x="0" y="0">
                Store
              </tspan>
            </text>
            <g data-name="vuesax/linear/bag-2" transform="translate(-532 1587)">
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path
                  d="M563.5 195.67v-.97a4.773 4.773 0 014.06-4.67 4.5 4.5 0 014.94 4.478v1.38"
                  data-name="Vector"
                ></path>
                <path
                  d="M565 210h6c4.02 0 4.74-1.61 4.95-3.57l.75-6c.27-2.44-.43-4.43-4.7-4.43h-8c-4.27 0-4.97 1.99-4.7 4.43l.75 6c.21 1.96.93 3.57 4.95 3.57z"
                  data-name="Vector"
                ></path>
                <path d="M571.496 200h.005" data-name="Vector"></path>
                <path d="M564.495 200h.005" data-name="Vector"></path>
              </g>
            </g>
          </g>
          <g transform="translate(-.01)">
            <text
              fill="var(--primary)"
              fontFamily="Inter"
              fontSize="12"
              opacity="0.5"
              transform="translate(16.01 244)"
            >
              <tspan x="0" y="0">
                Subscriptions
              </tspan>
            </text>
            <path
              fill="none"
              stroke="var(--white-10)"
              strokeWidth="1"
              d="M101.008 239.5h138.951"
              data-name="Path 1567"
            ></path>
          </g>
          <g opacity="0.7" transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1672)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Widgets"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 1698)"
            >
              <tspan x="0" y="0">
                Widgets
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/element-4"
              transform="translate(-660 1428)"
            >
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path
                  d="M706 262.9v-6.8c0-1.5-.64-2.1-2.23-2.1h-4.04c-1.59 0-2.23.6-2.23 2.1v6.8c0 1.5.64 2.1 2.23 2.1h4.04c1.59 0 2.23-.6 2.23-2.1z"
                  data-name="Vector"
                ></path>
                <path
                  d="M706 271.9v-1.8c0-1.5-.64-2.1-2.23-2.1h-4.04c-1.59 0-2.23.6-2.23 2.1v1.8c0 1.5.64 2.1 2.23 2.1h4.04c1.59 0 2.23-.6 2.23-2.1z"
                  data-name="Vector"
                ></path>
                <path
                  d="M694.5 265.1v6.8c0 1.5-.64 2.1-2.23 2.1h-4.04c-1.59 0-2.23-.6-2.23-2.1v-6.8c0-1.5.64-2.1 2.23-2.1h4.04c1.59 0 2.23.6 2.23 2.1z"
                  data-name="Vector"
                ></path>
                <path
                  d="M694.5 256.1v1.8c0 1.5-.64 2.1-2.23 2.1h-4.04c-1.59 0-2.23-.6-2.23-2.1v-1.8c0-1.5.64-2.1 2.23-2.1h4.04c1.59 0 2.23.6 2.23 2.1z"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <g transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1632)"
            ></rect>
            <text
              fill="var(--primary)"
              data-name="Templates"
              fontFamily="Inter"
              fontSize="14"
              opacity="0.7"
              transform="translate(60 1658)"
            >
              <tspan x="0" y="0">
                Templates
              </tspan>
            </text>
            <g
              data-name="vuesax/linear/note-2"
              opacity="0.7"
              transform="translate(-84 1388)"
            >
              <g fill="none" stroke="var(--primary)" strokeWidth="1">
                <path
                  d="M129.66 262.44l-.98 4.18c-.84 3.61-2.5 5.07-5.62 4.77a10.514 10.514 0 01-1.62-.27l-1.68-.4c-4.17-.99-5.46-3.05-4.48-7.23l.98-4.19a10.474 10.474 0 01.74-2.2c1.169-2.42 3.16-3.07 6.5-2.28l1.67.39c4.19.98 5.47 3.05 4.49 7.23z"
                  data-name="Vector"
                ></path>
                <path
                  d="M123.06 271.39a9.372 9.372 0 01-2.35 1.08l-1.58.52c-3.97 1.28-6.06.21-7.35-3.76l-1.28-3.95c-1.28-3.97-.22-6.07 3.75-7.35l1.58-.52a10.224 10.224 0 011.17-.31 10.474 10.474 0 00-.74 2.2l-.98 4.19c-.98 4.18.31 6.24 4.48 7.23l1.68.4a10.513 10.513 0 001.62.27z"
                  data-name="Vector"
                ></path>
                <path d="M120.64 260.53l4.85 1.23" data-name="Vector"></path>
                <path d="M119.66 264.4l2.9.74" data-name="Vector"></path>
              </g>
            </g>
          </g>
          <g data-name="Exercise Library" transform="translate(0 -1504)">
            <rect
              width="216"
              height="40"
              fill="none"
              data-name="Rectangle 4010"
              rx="8"
              transform="translate(12 1592)"
            ></rect>
            <text
              fill="var(--white-70)"
              data-name="Exercise Library"
              fontFamily="Inter"
              fontSize="14"
              transform="translate(60 1618)"
            >
              <tspan x="0" y="0">
                Exercise Library
              </tspan>
            </text>
            <g data-name="vuesax/linear/layer" transform="translate(-594 1218)">
              <g fill="none" stroke="var(--white-70)" strokeWidth="1">
                <path
                  d="M631.01 384.92l5.9 2.62c1.7.75 1.7 1.99 0 2.74l-5.9 2.615a3.42 3.42 0 01-2.44 0l-5.9-2.62c-1.7-.75-1.7-1.99 0-2.74l5.9-2.62a3.42 3.42 0 012.44.005z"
                  data-name="Vector"
                ></path>
                <path
                  d="M621 393a2.562 2.562 0 001.4 2.15l6.79 3.02a1.988 1.988 0 001.62 0l6.79-3.02A2.562 2.562 0 00639 393"
                  data-name="Vector"
                ></path>
                <path
                  d="M621 398a2.357 2.357 0 001.4 2.15l6.79 3.02a1.988 1.988 0 001.62 0l6.79-3.02A2.357 2.357 0 00639 398"
                  data-name="Vector"
                ></path>
              </g>
            </g>
          </g>
          <path
            fill="none"
            stroke="var(--white-10)"
            strokeWidth="1"
            d="M15.998 72h224"
            data-name="Path 1568"
          ></path>
          <path
            fill="var(--white-05)"
            stroke="var(--white-10)"
            strokeWidth="1"
            d="M240 .5V900"
            data-name="Path 1573"
          ></path>
          <g
            data-name="msb-logo-updates by Nisarg"
            transform="translate(-111.55 -314.281)"
          >
            <path
              fill="var(--primary)"
              d="M268.734 376.862c-.762-.279-1.411-.519-1.411-.921s.49-.653.974-.653a3.8 3.8 0 012.117.787l.056.046 1.058-1.909-.028-.032a4.679 4.679 0 00-3.175-1.041c-2.025 0-3.492 1.185-3.492 2.822 0 1.764 1.718 2.42 2.963 2.907.751.3 1.411.54 1.411.914 0 .617-.737.663-.96.663a4.107 4.107 0 01-2.282-.921l-.049-.042-1.316 1.764.035.035a5.291 5.291 0 003.591 1.291c2.388 0 3.478-1.482 3.478-2.868-.004-1.756-1.717-2.38-2.97-2.842z"
              data-name="Path 73"
              transform="translate(-88.703 -27.55)"
            ></path>
            <path
              fill="var(--primary)"
              d="M286.58 375.574h2.942v7.154h2.494v-7.154h2.942v-2.014h-8.378z"
              data-name="Path 74"
              transform="translate(-102.93 -27.822)"
            ></path>
            <path
              fill="var(--primary)"
              d="M319.812 378.943a2.762 2.762 0 001.432-2.5 2.688 2.688 0 00-1.813-2.685 5.293 5.293 0 00-1.9-.222h-3.441v9.172h2.491v-3.055h1.005l1.721 3.048h2.776l-1.937-3.26a3.755 3.755 0 00-.334-.498zm-1.1-2.371c0 .67-.43 1.058-1.185 1.058h-.97v-2.074h.741c1.182 0 1.411.4 1.411 1.034z"
              data-name="Path 75"
              transform="translate(-120.735 -27.8)"
            ></path>
            <path
              fill="var(--primary)"
              d="M344.084 379.12h2.956v-2.014h-2.956v-1.531h3.7v-2.015h-6.194v9.168h6.385v-2.014h-3.891z"
              data-name="Path 76"
              transform="translate(-138.534 -27.822)"
            ></path>
            <path
              fill="var(--primary)"
              d="M370.691 377.843c0 .3.025.677.056 1.016l-3.383-5.291h-2.494v9.172h2.494v-4.29c0-.3-.032-.706-.056-.995l3.394 5.267h2.469v-9.172h-2.491z"
              data-name="Path 77"
              transform="translate(-153.602 -27.815)"
            ></path>
            <path
              fill="var(--primary)"
              d="M422.43 375.574h2.942v7.154h2.491v-7.154h2.946v-2.014h-8.379z"
              data-name="Path 78"
              transform="translate(-190.857 -27.822)"
            ></path>
            <path
              fill="var(--primary)"
              d="M455.792 373.56v3.623h-3.408v-3.623h-2.494v9.168h2.494v-3.542h3.408v3.542h2.494v-9.168z"
              data-name="Path 79"
              transform="translate(-208.63 -27.822)"
            ></path>
            <path
              fill="var(--primary)"
              d="M398.785 379.377h1.743v.617a3.752 3.752 0 01-1.739.462c-1.764 0-2.8-.956-2.8-2.568s1.058-2.561 2.8-2.561a3.92 3.92 0 012.321.843l.049.042 1.206-1.792-.035-.032a5.617 5.617 0 00-3.76-1.249 4.84 4.84 0 00-5.14 4.737v.067a4.846 4.846 0 005.14 4.692 6.831 6.831 0 00.889-.056 4.921 4.921 0 003.383-1.764v-3.492h-4.057z"
              data-name="Path 80"
              transform="translate(-172.087 -27.55)"
            ></path>
            <path
              fill="var(--primary)"
              d="M487.565 378.227a2.117 2.117 0 001.139-1.937 2.352 2.352 0 00-2.639-2.3h-3.305v9.017h3.422c1.764 0 2.921-1.023 2.921-2.551a2.237 2.237 0 00-1.538-2.229zm.441 2.2a1.628 1.628 0 01-1.813 1.679h-2.371v-3.379h2.371a1.674 1.674 0 011.817 1.7zm-4.2-2.575v-2.962h2.247a1.406 1.406 0 011.57 1.46 1.446 1.446 0 01-1.383 1.506h-2.434z"
              data-name="Path 81"
              transform="translate(-229.904 -28.1)"
            ></path>
            <path
              fill="var(--primary)"
              d="M510.564 373.56a4.66 4.66 0 100 9.306 4.772 4.772 0 004.917-4.716 4.716 4.716 0 00-4.917-4.59zm3.824 4.6a3.824 3.824 0 11-3.82-3.66 3.82 3.82 0 013.82 3.664z"
              data-name="Path 82"
              transform="translate(-244.72 -27.822)"
            ></path>
            <path
              fill="var(--primary)"
              d="M542.917 373.56a4.718 4.718 0 00-4.917 4.6 4.92 4.92 0 009.832 0 4.718 4.718 0 00-4.915-4.6zm3.81 4.6a3.824 3.824 0 11-3.82-3.66 3.82 3.82 0 013.82 3.664z"
              data-name="Path 83"
              transform="translate(-265.658 -27.822)"
            ></path>
            <path
              fill="var(--primary)"
              d="M574.976 378.227l4.053-4.3H577.7l-4.441 4.664v-4.664H572.2v9.013h1.058v-2.921l1.023-1.079 3.729 4h1.33z"
              data-name="Path 84"
              transform="translate(-287.793 -28.061)"
            ></path>
            <path
              fill="var(--primary)"
              d="M241.276 378.4l-2.886-4.367-.018-.028h-1.322l3.708 5.581v3.432h1.037v-3.432L245.5 374h-1.319z"
              data-name="Path 85"
              transform="translate(-70.872 -28.106)"
            ></path>
            <path
              fill="var(--primary)"
              d="M211.082 380.438l-3.4-6.406-.018-.032h-1.4v9.01h1.036v-7.517l3.32 6.254.014.032h.9l3.337-6.286v7.517h1.029V374h-1.4z"
              data-name="Path 86"
              transform="translate(-50.944 -28.106)"
            ></path>
            <g
              fill="url(#linear-gradient-6)"
              data-name="Group 4126"
              transform="translate(127.55 337.281)"
            >
              <path
                d="M137.943 377.152c-.935-.441-4.27-2.6-4.273-11.077v-.042c0-8.466 3.338-10.643 4.273-11.084a.053.053 0 00-.025-.1c-5.41 0-6.754 5.531-7.058 9.07h-2.16a.914.914 0 00-.882.586 4.623 4.623 0 000 3.083.925.925 0 00.886.593h2.156c.318 3.528 1.662 9.055 7.075 9.07a.053.053 0 00.011-.1z"
                data-name="Path 87"
                transform="translate(-127.55 -352.993)"
              ></path>
              <path
                d="M178.065 377.152c-.935-.441-4.27-2.6-4.277-11.077v-.042c0-8.466 3.342-10.643 4.277-11.084a.053.053 0 00-.028-.1c-6.7.025-7.167 8.516-7.167 11.183v.042c0 2.667.452 11.158 7.167 11.176a.053.053 0 00.028-.1z"
                data-name="Path 88"
                transform="translate(-155.583 -352.993)"
              ></path>
              <path
                d="M156.692 362.657v-.039c0-9.6 4.785-12.417 5.823-12.918a.053.053 0 00-.025-.1c-7.986-.427-9.016 10.474-8.992 13.021v.039c-.032 2.529 1 13.451 9 13.031a.053.053 0 00.025-.1c-1.023-.506-5.831-3.321-5.831-12.934z"
                data-name="Path 89"
                transform="translate(-144.341 -349.585)"
              ></path>
            </g>
          </g>
          <rect
            width="208"
            height="32"
            fill="var(--background-color)"
            data-name="Rectangle 4631"
            rx="12"
            transform="translate(16 844)"
          ></rect>
          <rect
            width="100"
            height="24"
            fill="var(--white-05)"
            data-name="Rectangle 2"
            rx="8"
            transform="translate(120 848)"
          ></rect>
          <text
            fill="var(--primary)"
            fontFamily="Inter"
            fontSize="14"
            opacity="0.5"
            transform="translate(63 865)"
          >
            <tspan x="0" y="0">
              Light
            </tspan>
          </text>
          <g
            data-name="vuesax/linear/sun"
            opacity="0.5"
            transform="translate(-129 664)"
          >
            <g
              fill="none"
              stroke="var(--primary)"
              strokeWidth="1"
              transform="translate(172 188)"
            >
              <path
                d="M12.37 8A4.371 4.371 0 118 3.629 4.371 4.371 0 0112.37 8z"
                data-name="Vector"
              ></path>
              <path
                d="M12.683 3.32l.087-.087zm-9.452 9.45l.089-.087zM8 1.373h0zM8 14.68h0zM1.373 8h0zM14.68 8h0zM3.32 3.32l-.087-.087zm9.45 9.45l-.087-.087"
                data-name="Vector"
              ></path>
            </g>
          </g>
          <g data-name="vuesax/linear/moon" transform="translate(36 664)">
            <g transform="translate(108 188)">
              <path
                fill="url(#linear-gradient-9)"
                d="M.018 6.951a7.005 7.005 0 0012.622 3.534c.547-.74.253-1.234-.66-1.067a6.33 6.33 0 01-1.387.093A6.217 6.217 0 014.652 3.43a5.931 5.931 0 01.5-2.43c.36-.83-.073-1.223-.907-.87A6.868 6.868 0 00.018 6.951z"
                data-name="Vector"
                transform="translate(1.335 1.33)"
              ></path>
            </g>
          </g>
          <text
            fill="var(--primary)"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="600"
            transform="translate(164 865)"
          >
            <tspan x="0" y="0">
              Dark
            </tspan>
          </text>
          <rect
            width="48"
            height="32"
            fill="var(--background-color)"
            data-name="Rectangle 8004"
            rx="12"
            transform="translate(16 804)"
          ></rect>
          <g data-name="vuesax/linear/send" transform="translate(30 810.001)">
            <g
              fill="none"
              stroke="var(--primary)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            >
              <path
                d="M11.932 3.956L5.286 7.284c-2.981 1.493-2.981 3.935 0 5.428l6.646 3.328c4.472 2.239 6.3.4 4.06-4.067l-.675-1.345a1.593 1.593 0 010-1.252l.675-1.353c2.236-4.471.404-6.306-4.06-4.067z"
                data-name="Vector"
              ></path>
              <path d="M11.946 9.999h-1.618" data-name="Vector"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default WebAppPreview;
